module.exports = __webpack_public_path__ + "media/images/hamb-white-0150e46ab399744c57cac33ca096beae.svg";